export function formatShortId(id: string): string {
  if (id.length <= 10) {
    return id;
  }

  return `${id.slice(0, 6)}...${id.slice(-4)}`;
}

export function entityViewTitle(id: string | undefined, label: string): string {
  if (!id) {
    return label;
  }

  return `${formatShortId(id)} - ${label}`;
}

export function ID({ id }: { id?: string }) {
  if (!id) {
    return null;
  }

  return formatShortId(id);
}
